<template>
  <div>
    <div class="check-list-name p-mb-1">
      {{ __("check list") }} - {{ checkListData.mtcCheckListName }}
    </div>
    <div class="check-list-name p-mb-3">
      {{ __("Reading") }}: {{ PID }} - {{ this.problemSubject?.slice(0, 30) }}
    </div>
    <local-chapter
      class="chapter"
      v-for="(chapter, index) of chapters"
      :key="index"
      :chapter="chapter"
      :BID="BID"
      @collapsedChapter="collapsedChapter"
      @showResultPanel="showResultPanel"
      @refreshServiceCall="$emit('refreshServiceCall', $event)"
    ></local-chapter>
    <div class="p-d-flex p-jc-between" v-if="chapters">
      <p-vue-button
        class="button p-button-rounded p-button-success p-mt-2"
        :label="__('Finished testing')"
        @click="checkCloseCheckList"
      />
      <p-vue-button
        v-if="allowSendChecklistReportToVaad"
        class="button p-button-rounded p-button-success p-mt-2"
        :label="__('Send to committee')"
        @click="SendToVaad"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { errorReceived, showSuccessOrFailedModal } from "@/services/apointUtil";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import LocalChapter from "./chapter";
import { __ } from "@/plugins/i18n/";

export default {
  components: {
    LocalChapter,
  },
  props: {
    PID: Number,
    BID: Number,
    mtcCheckListID: Number,
    problemSubject: String,
  },
  emits: ["refreshServiceCall", "closeCheckList"],
  data() {
    return {
      checkListData: {},
      chapters: [],
      allowSendChecklistReportToVaad: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("userID", this.userNum, apiPType.Int),
        apiParam("PID", this.PID, apiPType.Int),
        apiParam("mtcCheckListID", this.mtcCheckListID, apiPType.Int),
      ];
      callProc("WorkerApp_CheckListData", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log("WorkerApp_CheckListData", result);
          this.checkListData = result.Table[0];
          let items = result.Table2;
          items.forEach((item) => {
            item.Images = result.Table3.filter(
              (f) => f.mtcCheckListItemID == item.mtcCheckListTemplateItemID
            );
          });
          this.chapters = result.Table1;
          this.chapters.forEach((chapter) => {
            chapter.items = items.filter(
              (f) => f.mtcChapterID == chapter.mtcChapterID
            );
          });
          this.allowSendChecklistReportToVaad =
            result.Table4[0].allowSendChecklistReportToVaad != 0;
          // console.log(this.chapters);
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_UpdateServiceCallStatus");
        });
    },
    collapsedChapter(chapter, collapsed) {
      this.chapters.forEach((c) => {
        c.Collapsed = false;
      });
      chapter.Collapsed = collapsed;
    },
    checkCloseCheckList(event) {
      if (!this.checkResultsInCheckList()) {
        this.$confirm.require({
          target: event.currentTarget,
          message: __(
            "Note: Not all tests have been completed, should continue?"
          ),
          icon: "pi pi-exclamation-triangle",
          accept: () => {
            this.CloseCheckList();
          },
        });
      } else this.CloseCheckList();
    },
    CloseCheckList() {
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam("PID", this.PID, apiPType.Int),
        apiParam("IsTreated", true, apiPType.Bit),
        apiParam("IsSmsSend", false, apiPType.Bit),
      ];
      callProc("WorkerApp_UpdateServiceCallStatus", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log(result);
          if (result.procReturnValue == 0) {
            if (result.Table && result.Table[0]) {
              this.$emit("refreshServiceCall", result.Table[0]);
            }
          } else {
            showSuccessOrFailedModal(
              __("There was an error closing the referral"),
              false
            );
          }
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_UpdateServiceCallStatus");
        });
    },
    checkResultsInCheckList() {
      for (let chapter of this.chapters) {
        if (chapter.items.filter((item) => item.checkResult == 1).length > 0) {
          return false;
        }
      }
      return true;
    },
    SendToVaad(event) {
      if (!this.checkResultsInCheckList()) {
        this.$confirm.require({
          target: event.currentTarget,
          message: __(
            "Note: There are tests in 'Unchecked' status. Should I continue sending to the committee?"
          ),
          icon: "pi pi-exclamation-triangle",
          accept: () => {
            this.createHtmlAndSendToVaad();
          },
        });
      } else this.createHtmlAndSendToVaad();
    },
    createHtmlAndSendToVaad() {
      let html = this.createHtml();
      let subject =
        'דו"ח תחזוקה בנושא: ' +
        this.checkListData.mtcCheckListName +
        " שבוצע בתאריך : #closeDate#";
      let procParams = [
        apiParam("PID", this.PID, apiPType.Int),
        apiParam("body", html, apiPType.NVarChar),
        apiParam("subject", subject, apiPType.NVarChar),
      ];
      callProc("sendChecklistToVaad", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log(result);
          if (result.procReturnValue == 0) {
            showSuccessOrFailedModal(
              __("The report was submitted successfully"),
              true,
              5000
            );
          } else {
            showSuccessOrFailedModal(
              __("There was an error submitting the report"),
              false,
              5000
            );
          }
          setTimeout(() => {
            this.$emit("closeCheckList");
          }, 5000);
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("sendChecklistToVaad");
        });
    },
    createHtml() {
      let image = "";
      let html = "";
      html =
        "<!DOCTYPE html><html dir ='rtl'><head></head><body><table style='width:80%;margin-left:auto;margin-right:auto;direction: rtl;' >";
      html += "<tr>";
      html +=
        "<td colspan=3 style='text-align:center'><img src='" +
        image +
        "' alt='Logo' /></td>";
      html += "</tr>";

      html += "<tr>";
      html +=
        "<td colspan=3 style='text-align:center;font-size:14pt;font-family:Arial'>דו\"ח תחזוקה בנושא : " +
        this.checkListData.mtcCheckListName +
        " שבוצע בתאריך : #closeDate#</td>";
      html += "</tr>";

      html += "<tr>";
      html +=
        "<td colspan=3 style='text-align:right;font-size:14pt;font-family:Arial'>כתובת הבניין : #fullAddress#</td>";
      html += "</tr>";

      html += "<tr>";
      html +=
        "<td colspan=3 style='text-align:right;font-size:14pt;font-family:Arial'>שם מבצע : #closedBy#</td>";
      html += "</tr>";

      html += "<tr>";
      html +=
        "<td colspan=3 style='text-align:right;font-size:14pt;font-family:Arial'>תאריך ביצוע : #closeDate#</td>";
      html += "</tr>";

      this.chapters.forEach((chapter) => {
        html += "<tr>";
        html +=
          "<td colspan=3 style='background-color:#82b3ff;color:#ffffff;font-family:Arial'>" +
          chapter.mtcChapterName +
          "</td>";
        html += "</tr>";

        chapter.items.forEach((item) => {
          html += "<tr style='font-family:Arial;border-bottom: solid 1px gray;'>";
          html +=
            "<td>" +
            item.mtcItemName +
            "</td><td>" +
            this.getStatusName(item.checkResult) +
            "</td><td>" +
            (item.remarks ? item.remarks : "") +
            "</td>";
          html += "</tr>";
        });
      });

      html += "</table></body></html>";
      console.log("html",html);
      return html;
    },
    getStatusName(status) {
      switch (status) {
        case 1:
          return "לא נבדק";
        case 2:
          return "תקין";
        case 3:
          return "לא תקין";
      }
    },
    showResultPanel(item) {
      this.chapters.forEach((c) => {
        c.items.forEach((i) => {
          i.showResultPanel = false;
        });
      });
      item.showResultPanel = true;
    },
  },
  computed: {
    ...mapState({
      userNum: (state) => state.api.workerID,
    }),
  },
};
</script>

<style scoped>
.chapter {
  border: 1px solid #c8cacd;
  border-radius: 3px;
  margin: 5px;
}

.check-list-name {
  font-weight: bold;
  text-align: center;
}
</style>
